import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useScroll } from "../context/scroll-context";
import '../pages/hire-developers/hire-developer.css'

const PricingCards = ({ developer }) => {
  const { scrollToSection, pricing, contactform } = useScroll();

  const handleScrollAndClose = (refName) => {
    scrollToSection(refName);
  };

  // Helper function to determine the correct article
  const getArticle = (word) => {
    const vowels = ["a", "e", "i", "o", "u"];
    return vowels.includes(word[0].toLowerCase()) ? "an" : "a";
  };

  const plans = [
    {
      id: 1,
      price: "$15",
      duration: "Hourly (USD)",
      context: `On-Demand ${developer} Engineer with fully signed NDA`,
    },
    {
      id: 2,
      price: "$2400",
      duration: "Monthly (USD)",
      context: `100% dedicated ${developer} Engineer with fully signed NDA`,
    },
    {
      id: 3,
      price: "Looking For a Fixed Price?",
      duration: "",
      context: "On Time Delivery",
    },
  ];

  return (
    <section className="pricing-cards-section" ref={pricing}>
      <Container fluid>
        <Row className="justify-content-center">
          <Col xs="12" className="text-center mb-5">
            <h2 className="text-primary mb-0 text-uppercase ft-wt-600 mb-4">
              Hire {getArticle(developer)} {developer} Developer As Per Your
              Need
            </h2>
            <p className="text-primary">
              Transparent Process | Security Covered By ISO 27001:2022 | Fully
              signed NDA | Simple Exit Process
            </p>
          </Col>
          {plans.map((plan, index) => (
            <Col key={plan.id} md={6} lg={4} className="mb-4">
              <Card
                className={`pricing-card h-100 ${index === 1 ? "selected" : ""
                  }`}
                onClick={() => handleScrollAndClose(contactform)}
              >
                <Card.Body className="d-flex flex-column text-white justify-content-center">
                  {index === 1 && (
                    <div className="pricing-label">
                      <h5 className="mb-0">Starts with</h5>
                    </div>
                  )}

                  <h2 className="text-center text-uppercase ft-wt-600">
                    {plan.price}
                  </h2>
                  <h4 className="text-center mb-4 ft-wt-600">
                    {plan.duration}
                  </h4>
                  <h4 className="text-capitalize mb-0 ft-wt-500">
                    {plan.context}
                  </h4>
                </Card.Body>
              </Card>
            </Col>
          ))}
          <Col xs="12" className="text-center">
            <Button
              className="text-uppercase"
              variant="primary"
              onClick={() => handleScrollAndClose(contactform)}
            >
              Schedule a developer interview
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PricingCards;
